// extracted by mini-css-extract-plugin
export default {"wrapper":"cookieCategoryControl_wrapper","requiredLabel":"cookieCategoryControl_requiredLabel"};